import React from "react";
import firebase from "firebase";
import { auth, db } from "../../fire";
import { PrimaryButton } from "../../Components/PrimaryButton";
import styles from "./index.module.css";
import { Link } from "react-router-dom";
import { Routes } from "../../Routes";
import { Images } from "../../Assets/Images";
import { PasswordInput } from "../../Components/TextInput";

export class Login extends React.Component {
  state = {
    email: "",
    password: "",
    keepLogged: false,
    isSigninIn: false,
    errorMessage: ""
  };

  doLogin = async e => {
    e.preventDefault();
    const { email, password, keepLogged } = this.state;

    this.setState({ isSigninIn: true, errorMessage: "" });

    if (!keepLogged) {
      await auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);
    }

    try {
      const { user } = await auth.signInWithEmailAndPassword(email, password);

      const userRef = await db
        .collection("users")
        .doc(user.uid)
        .get();

      const userData = userRef.data();

      if (!userData || !userData.prestadorDeServico) {
        this.setState({
          isSigninIn: false,
          errorMessage: "Não autorizado"
        });
        return auth.signOut();
      }

      this.props.history.push(Routes.HOME);
    } catch (error) {
      if (error.code === "auth/invalid-email") {
        this.setState({
          isSigninIn: false,
          errorMessage: "Escreva um email válido"
        });
      } else if (error.code === "auth/wrong-password") {
        this.setState({
          isSigninIn: false,
          errorMessage: "Senha incorreta"
        });
      } else if (error.code === "auth/user-not-found") {
        this.setState({
          isSigninIn: false,
          errorMessage: "Usuário não encontrado"
        });
      } else if (error.code === "auth/user-disabled") {
        this.setState({
          isSigninIn: false,
          errorMessage: "Não autorizado"
        });
      }
    }
  };

  render() {
    const {
      email,
      password,
      keepLogged,
      isSigninIn,
      errorMessage
    } = this.state;

    return (
      <div className="d-flex flex-column align-items-center justify-content-center h-100">
        <img width={280} src={Images.logo} alt="GoBrain" />
        <div className={styles["form-container"]}>
          <h1 className="text-center h4 mb-4">Entrar</h1>
          <form onSubmit={this.doLogin} className="mb-4">
            <p className="text-danger text-center">{errorMessage}</p>
            <div className="form-group mb-4">
              <input
                value={email}
                onChange={e => this.setState({ email: e.target.value })}
                type="email"
                required
                id="email"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <PasswordInput
                value={password}
                onChange={e => this.setState({ password: e.target.value })}
                required
                id="password"
                className="form-control"
              />
            </div>
            <div className="d-flex justify-content-between p-2 pl-5 pr-5">
              <div className="form-group">
                <div className="custom-control custom-checkbox mr-sm-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="keepLogged"
                    value={keepLogged}
                    onChange={() => {
                      this.setState({ keepLogged: !keepLogged });
                    }}
                  />
                  <label
                    className="custom-control-label text-body"
                    htmlFor="keepLogged"
                  >
                    Lembrar-me
                  </label>
                </div>
              </div>
              <Link to="/#" className="text-decoration-none">
                Esqueceu a senha
              </Link>
            </div>
            <PrimaryButton type="submit" disabled={isSigninIn} block>
              {isSigninIn ? "Entrando" : "Entrar"}
            </PrimaryButton>
          </form>
          <p className="text-center">
            Quer fazer parte?{" "}
            <Link to={Routes.REGISTER} className="text-decoration-none">
              Cadastre-se
            </Link>
          </p>
        </div>
      </div>
    );
  }
}
